/* eslint-disable react-hooks/exhaustive-deps */
import { BackgroundCard, MessageBox } from '@davies-group/white-label-ui/ui';
import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { useDocumentUpload } from '../../context/DocumentUploadContext';
import { IPage } from '../IPage';

export const ErrorPage = () => {
    const { state, dispatch } = useDocumentUpload();

    React.useEffect(() => {
        dispatch({ type: 'updateIsLoading', payload: false });
    }, []);

    return (
        <BackgroundCard>
            <Box p={4} justifyContent="center">
                <Box pb={2} width={1} display="flex" alignItems="flex-start">
                    <Typography color="secondary" align="left" variant="h4">
                        <strong>Error</strong>
                    </Typography>
                </Box>

                <Box pb={2} width={1}>
                    <MessageBox>{state && state.error ? <Typography sx={{ fontWeight: 'bold' }}>Error Text - Error Message: {state.error}</Typography> : <Typography sx={{ fontWeight: 'bold' }}>Error Text - Invalid or no requestId</Typography>}</MessageBox>
                </Box>
            </Box>
        </BackgroundCard>
    );
};

const errorPage: IPage = {
    title: 'ErrorPage',
    route: {
        path: '/:requestId/error',
        element: <ErrorPage />,
    },
};

export default errorPage;
